<template>
  <div>
    <button class="focus:shadow-outline my-2" @click="handleLogoClick">
      <Logo
        :class="contain ? 'h-10 w-10' : 'max-h-full'"
        :style="{ maxWidth: contain ? '10rem' : '100%' }"
        alt="LOGO.com"
      />
    </button>
  </div>
</template>

<script>
import Logo from '@/assets/img/logo/logo.svg?inline'

export default {
  components: { Logo },
  props: {
    contain: { type: Boolean, default: true },
  },

  methods: {
    handleLogoClick() {
      if (!this.$route?.params?.pkg) {
        this.$router.push(`/dashboard`)

        return
      }

      this.$router.push(`/dashboard/${this.$route.params.pkg}`)
    },
  },
}
</script>
